
import u from "umbrellajs"
import _once from "lodash/once"
import _mapValues from "lodash/mapValues"

const get$Html = _once(() => u("html"))

const isIPhone = () => get$Html().data("mobile-os-iphone") != null
const isIPad = () => get$Html().data("mobile-os-ipad") != null
const isIPod = () => get$Html().data("mobile-os-ipod") != null
const isAndroid = () => get$Html().data("mobile-os-android") != null

const isIOS = () => [isIPhone, isIPad, isIPod].some((func) => func())

const MobileOsDetection = _mapValues({
  isIPhone,
  isIPad,
  isIPod,
  isAndroid,
  isIOS,
}, (func) => _once(func))

export default MobileOsDetection
